import Post from '../api'
//盘口调度平台*****************

// 读取所有代理商名字与id
export const GetAllAgent = (param: object): any => {
    return Post('GetAllAgent', param)
}
// 获取代理商列表
export const GetAgentList = (param: object): any => {
    return Post('GetAgentList', param)
}

// 保存代理商配置
export const SaveAgent = (param: object): any => {
    return Post('SaveAgent', param)
}
// 删除代理商配置
export const DelAgent = (param: object): any => {
    return Post('DelAgent', param)
}

//读取代理商结算配置
export const GetAgentSettle = (param: object): any => {
    return Post('GetAgentSettle', param)
}
//读取代理商结算配置
export const SaveAgentSettle = (param: object): any => {
    return Post('SaveAgentSettle', param)
}

// 获取代理商产品列表
export const GetAgentChannelList = (param: object): any => {
    return Post('GetAgentChannelList', param)
}
//删除代理商产品
export const DeleteAgentChannel = (param: object): any => {
    return Post('DeleteAgentChannel', param)
}
//保存代理商产品配置
export const SaveAgentChannel = (param: object): any => {
    return Post('SaveAgentChannel', param)
}

//保存代理商产品配置
export const ChangeAgentBalance = (param: object): any => {
    return Post('ChangeAgentBalance', param)
}

//获取商户列表
export const GetTradeList = (param: object): any => {
    return Post('GetTradeList', param)
}
//获取商户列表
export const GetAllTrade = (param: object): any => {
    return Post('GetAllTrade', param)
}

//保存商户配置
export const SaveTrade = (param: object): any => {
    return Post('SaveTrade', param)
}

//删除商户
export const DelTrade = (param: object): any => {
    return Post('DelTrade', param)
}

//读取商户结算配置
export const GetTradeSettle = (param: object): any => {
    return Post('GetTradeSettle', param)
}
//保存商户结算配置
export const SaveTradeSettle = (param: object): any => {
    return Post('SaveTradeSettle', param)
}

//读取商户通道配置
export const GetTradeChannelList = (param: object): any => {
    return Post('GetTradeChannelList', param)
}
//保存商户通道配置
export const SaveTradeChannel = (param: object): any => {
    return Post('SaveTradeChannel', param)
}

//删除商户通道配置
export const DelTradeChannel = (param: object): any => {
    return Post('DelTradeChannel', param)
}

//读取商户app
export const GetTradeAppList = (param: object): any => {
    return Post('GetTradeAppList', param)
}

//读取商户app
export const SaveTradeApp = (param: object): any => {
    return Post('SaveTradeApp', param)
}

//删除商户app
export const DelTradeApp = (param: object): any => {
    return Post('DelTradeApp', param)
}

//修改商户账户金额
export const ChangeTradeBalance = (param: object): any => {
    return Post('ChangeTradeBalance', param)
}
// 保存商户通道配置
export const saveTradeChannel = (param: object): any => {
    return Post('saveTradeChannel', param)
}

// 保存支付平台通道配置
export const SaveMchConfig = (param: object): any => {
    return Post('SaveMchConfig', param)
}

// 获取支付商通道列表
export const GetAllMchChannel = (param: object): any => {
    return Post('GetAllMchChannel', param)
}
// 获取支付商通道列表
export const GetAllMchConfig = (param: object): any => {
    return Post('GetAllMchConfig', param)
}

// 删除支付商
export const DeleteMchConfig = (param: object): any => {
    return Post('DeleteMchConfig', param)
}

// 删除支付商
export const GetMchConfigList = (param: object): any => {
    return Post('GetMchConfigList', param)
}

// 获取支付商通道列表
export const GetMchChannelList = (param: object): any => {
    return Post('GetMchChannelList', param)
}

// 保存支付平台通道配置
export const SaveMchChannel = (param: object): any => {
    return Post('SaveMchChannel', param)
}

// 删除支付平台通道配置
export const DeleteMchChannel = (param: object): any => {
    return Post('DeleteMchChannel', param)
}

// 所有支付产品
export const GetAllDisChannel = (param: object): any => {
    return Post('GetAllDisChannel', param)
}

// 保存产品配置
export const SaveDisChannel = (param: object): any => {
    return Post('SaveDisChannel', param)
}

// 删除支付产品
export const GetDisChannelList = (param: object): any => {
    return Post('GetDisChannelList', param)
}

// 获取产品列表
export const DeleteDisChannel = (param: object): any => {
    return Post('DeleteDisChannel', param)
}
// 查看支付产品金额信息
export const GetDisChannelMoney = (param: object): any => {
    return Post('GetDisChannelMoney', param)
}

//获取产品支付通道详情
export const GetDisChannelSetting = (param: object): any => {
    return Post('GetDisChannelSetting', param)
}

//删除支付产品通道
export const DelDisChannelSetting = (param: object): any => {
    return Post('DelDisChannelSetting', param)
}
//修改产品支付通道权重
export const UpdateDisChannelSetting = (param: object): any => {
    return Post('UpdateDisChannelSetting', param)
}

// 给产品添加支付通道
export const AddDisChannelSetting = (param: object): any => {
    return Post('AddDisChannelSetting', param)
}

// 代理商流水明细
export const GetAgentAmountRecodeList = (param: object): any => {
    return Post('GetAgentAmountRecodeList', param)
}

// 商户流水明细
export const GetTradeAmountRecodeList = (param: object): any => {
    return Post('GetTradeAmountRecodeList', param)
}

// 读取默认结算配置
export const GetSysSettle = (param: object): any => {
    return Post('GetSysSettle', param)
}

// 保存默认结算配置
export const SaveSysSettle = (param: object): any => {
    return Post('SaveSysSettle', param)
}

// 商户收款账户删除
export const DelTradeBank = (param: object): any => {
    return Post('DelTradeBank', param)
}

// 商户收款账户列表
export const GetTradeBankList = (param: object): any => {
    return Post('GetTradeBankList', param)
}

// 商户收款账户保存
export const SaveTradeBank = (param: object): any => {
    return Post('SaveTradeBank', param)
}

// 结算订单列表
export const GetSettleOrderList = (param: object): any => {
    return Post('GetSettleOrderList', param)
}

//结算订单统计
export const CoolectSettleOrder = (param: object): any => {
    return Post('CoolectSettleOrder', param)
}

// 结算订单审核
export const CheckSettleOrder = (param: object): any => {
    return Post('CheckSettleOrder', param)
}

// 结算订单绑定打款人
export const BindSettleOrder = (param: object): any => {
    return Post('BindSettleOrder', param)
}

// 结算订单绑定打款人
export const PaySettleOrder = (param: object): any => {
    return Post('PaySettleOrder', param)
}

// 管理后台日志列表
export const GetAdminLogList = (param: object): any => {
    return Post('GetAdminLogList', param)
}
// 商户日志列表
export const GetTradeLogList = (param: object): any => {
    return Post('GetTradeLogList', param)
}

// 结算订单解绑打款人
export const UnBindSettleOrder = (param: object): any => {
    return Post('UnBindSettleOrder', param)
}

// 订单管理
//结算订单详情
export const GetSettleOrder = (param: object): any => {
    return Post('GetSettleOrder', param)
}

//支付订单列表
export const GetPayOrderList = (param: object): any => {
    return Post('GetPayOrderList', param)
}
//支付订单列表
export const GetPayOrder = (param: object): any => {
    return Post('GetPayOrder', param)
}
//补单回调
export const NoticePayOrder = (param: object): any => {
    return Post('NoticePayOrder', param)
}
//测试回调
export const NoticeTestPayOrder = (param: object): any => {
    return Post('NoticeTestPayOrder', param)
}
//测试回调
export const PayOrderSuccess = (param: object): any => {
    return Post('PayOrderSuccess', param)
}
//统计信息
export const CoolectPayOrder = (param: object): any => {
    return Post('CoolectPayOrder', param)
}

//商户支付成功率
export const CollectTradeSuccRate = (param: object): any => {
    return Post('CollectTradeSuccRate', param)
}
//商户支付通道统计
export const CollectTradeChannelDailyRecode = (param: object): any => {
    return Post('CollectTradeChannelDailyRecode', param)
}
//商户收款数据统计
export const CollectTradeDailyRecode = (param: object): any => {
    return Post('CollectTradeDailyRecode', param)
}
//平台数据统计
export const CollectDisPayData = (param: object): any => {
    return Post('CollectDisPayData', param)
}
//代理商分润数据统计
export const CollectAgentDailyRecode = (param: object): any => {
    return Post('CollectAgentDailyRecode', param)
}
//支付产品据统计
export const CollectDisChannelDailyRecode = (param: object): any => {
    return Post('CollectDisChannelDailyRecode', param)
}
//支付通道数据统计
export const CollectMchChannelDailyRecode = (param: object): any => {
    return Post('CollectMchChannelDailyRecode', param)
}
//支付平台数据统计
export const CollectMchConfigDailyRecode = (param: object): any => {
    return Post('CollectMchConfigDailyRecode', param)
}
//平台7日数据统计
export const CollectSevenDayData = (param: object): any => {
    return Post('CollectSevenDayData', param)
}
// 平台总数据统计
export const CollectTotalData = (param: object): any => {
    return Post('CollectTotalData', param)
}
